interface Channel {
    activityId: number;
    id: number;
    label: string;
    isSelfService: boolean;
    isSupported: boolean;
}

export interface ActivityStats {
    channels: Channel[];
    count: number;
    id: number;
    label: string;
    order: number;
}

export interface ChannelStats extends Channel {
    activityLabel: string;
    count: number;
}

export interface SpecialRequestStats {
    count: number;
}

export interface PlannerStats {
    activities: ActivityStats[];
    channels: ChannelStats[];
    count: number;
    supported: number;
    general: number;
    selfService: number;
}

export interface PublishedArtifactStats {
    countByClients: number;
    countByManagers: number;
    count: number;
}

export interface LastLogin {
    firstName: string;
    lastName: string;
    lastLoginAt: Date;
}

export interface InternalStats {
    planners: PlannerStats;
    specialRequests: SpecialRequestStats;
    publishedArtifacts: PublishedArtifactStats;
    lastLogin: LastLogin;
}

export function getLastLoginName(lastLogin: LastLogin): string | undefined {

    if (!lastLogin) {
        return undefined;
    } else {
        return `${lastLogin.firstName} ${lastLogin.lastName}`;
    }
}
